import React, { FunctionComponent } from "react";

import { CriteriaInput } from "./Criteria/CriteriaInput";
import { OrdersDateSelect } from "./Date/OrdersDateSelect";
import { OrdersSizeSelect } from "./Size/OrdersSizeSelect";

export const QuoteFilters: FunctionComponent = () => {
  return (
    <form className="p-4 flex flex-col md:flex-row gap-2" noValidate>
      <OrdersSizeSelect />
      <OrdersDateSelect />
      <CriteriaInput />
    </form>
  );
};
